import { FC } from "react";

import { Box } from "@chakra-ui/react";

import { FeaturedProjectCard, ImagePosition } from "pages/featured-work/featured-work-card/FeaturedWorkCard";
import { configs } from "shared/content/Content";
import { WorkPageId } from "utils/useScroll";
import { PageHeader } from "shared/page-header/PageHeader";

export const FeaturedWork: FC = () => {
    return (


        <Box id={WorkPageId}>
            <PageHeader label="Some of My Successes" />
            <Box
                id="featured-projects"
                display={{ base: "block", md: "flex", lg: "block" }}
                flexDir="column"
                gap={{ base: "2", md: "1" }}
            >
                {configs.featuredWork.map((project, idx) => (
                    <FeaturedProjectCard
                        imagePosition={idx % 2 === 0 ? ImagePosition.Right : ImagePosition.Left}
                        key={project.id}
                        {...project}
                    />
                ))}
            </Box>
        </Box>
    );
};
